import React, { useEffect, useRef } from 'react';
import { useStyles } from './LoginPage.styles';
import { useAuth } from 'app/shared/providers';
import { CircularProgress } from 'app/shared/components/generic-ui/CircularProgress';
import { useNavigate } from 'react-router';

export function LoginPage() {
  const { signIn, isLoading } = useAuth();
  const { classes } = useStyles();
  const navigate = useNavigate();
  const pathname = localStorage.getItem('redirectUrl');
  const hasStartedSignIn = useRef(false);

  const handleSignIn = async () => {
    if (!isLoading) {
      await signIn();
    }
  };

  useEffect(() => {
    // StrictMode mounts effects twice in development; start one redirect only.
    if (hasStartedSignIn.current) {
      return;
    }
    hasStartedSignIn.current = true;

    handleSignIn();

    if (pathname) {
      navigate(pathname, { replace: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={classes.pageWrapper}>
      <CircularProgress size={50} withLabel />
    </div>
  );
}
